import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { produce } from 'immer';
import { fileServiceActions } from './file.actions';

export const FileKey = 'file';

export interface File {
  key: string;
  url: string;
  loadedTime: number;
}

export interface FileState extends EntityState<File> {
  error?: Error;
}

export function selectFileKey(file: File) {
  return file.key;
}

export const fileAdapter: EntityAdapter<File> = createEntityAdapter<File>({
  selectId: selectFileKey,
});

export const initialFileState: FileState = fileAdapter.getInitialState({
  error: undefined,
});

export const fileReducer = createReducer(
  initialFileState,
  on(
    fileServiceActions.getSuccess,
    (state, { file }): FileState =>
      fileAdapter.upsertOne(
        file,
        produce(state, (draft) => {
          draft.error = undefined;
        })
      )
  ),
  on(
    fileServiceActions.listSuccess,
    (state, { files }): FileState =>
      fileAdapter.upsertMany(
        files,
        produce(state, (draft) => {
          draft.error = undefined;
        })
      )
  ),
  on(
    fileServiceActions.getFailure,
    fileServiceActions.listFailure,
    (state, { error }): FileState =>
      produce(state, (draft) => {
        draft.error = error;
      })
  )
);
